import { render, staticRenderFns } from "./PrognosePanel.vue?vue&type=template&id=0201798c&"
import script from "./PrognosePanel.vue?vue&type=script&lang=js&"
export * from "./PrognosePanel.vue?vue&type=script&lang=js&"
import style0 from "./PrognosePanel.vue?vue&type=style&index=0&id=0201798c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports